import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SlicePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { pygRange } from '@pyg-shared/utils';
import { LangRouterLink } from '@pyg-directives/lang-router-link.directive';

@Component({
  selector: 'app-vq-benefits',
  templateUrl: './vq-benefits.component.html',
  styleUrls: ['./vq-benefits.component.scss'],
  imports: [SlicePipe, TranslatePipe, LangRouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VqBenefitsComponent {
  public readonly benefits = pygRange(1, 10);
}
